// src/data/scriptsList.js

export const scriptsList = [
  {
    name: "Upload Bulk Word Audios",
    path: "/scripts/upload_bulk_word_audios",
    description: "Upload word audio files in bulk via CSV and ZIP.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1BV4f55hwu_mH66geAYH7e_IOAN-0IWNhigwq9D3YP_o/edit?usp=sharing",
  },
  {
    name: "Upload Textbook Passages",
    path: "/scripts/upload_bulk_textbook_passages_and_audios",
    description: "Upload textbook passages and their corresponding audios.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1ScqDN5dGUofrozB4nT7YaMu9ATFMKJLjZ0Zq-Aa1izw/edit?usp=sharing",
  },
  {
    name: "Upload Story Passages",
    path: "/scripts/upload_bulk_story_passages_and_audios",
    description: "Upload story passages with their associated audios.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1ur4fAntALsTaMk9kFAFmqA4QgrXlwGXIeSjVHWIBScc/edit?usp=sharing",
  },
  {
    name: "Upload Image Passages",
    path: "/scripts/upload_bulk_image_passages_and_audios",
    description: "Upload images with related audio content for visual learning.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1I1I53ASs3sFV4D9tNx2nT1st14Mxz9i189RALj4vkLM/edit?usp=sharing",
  },
  {
    name: "Download Report",
    path: "/scripts/downloadreport",
    description: "Download CSV reports of recent uploads or system actions.",
    sheet_link: "https://sheet.new",
  },
  {
    name: "Delete Form Data",
    path: "/scripts/deleteform",
    description: "Delete uploaded data entries from the system safely.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1TvZf89svcKMCT96ukKq29bZ9-aBouPQuHze-G_LNdn0/edit?usp=sharing",
  },
  {
    name: "Delete Image",
    path: "/scripts/deleteimage",
    description: "Delete images ",
    sheet_link: "https://docs.google.com/spreadsheets/d/1VrHiT69XIpE8uijzgR63aJPolzqWsVqtLHJrGPxLbp4/edit?usp=sharing",
  },
  {
    name: "Bulk User Upload",
    path: "/scripts/bulkuser",
    description: "Upload multiple user accounts at once using a CSV file.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1Kp7oGike8KItQODZtPLg4ZYsm4jhsjCX5bQO9VmHAEE/edit?usp=sharing",
  },
  {
    name: "Upload Word Meanings",
    path: "/scripts/upload_meaning",
    description: "Upload or update multiple word meanings efficiently.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1JUn60tcyl-PKIT-unF4GyWshjndvP5KeyVrKbNnw8ug/edit?usp=sharing",
  },
  {
    name: "Upload User Subscriptions",
    path: "/scripts/upload_user_subscription",
    description: "Create or update user subscriptions in bulk via spreadsheet.",
    sheet_link: "https://sheet.new",
  },
  {
    name: "Link Word Content with Reading Content",
    path: "/scripts/passage_word_mapping",
    description: "Link word-related content with specific reading materials.",
    sheet_link: "https://docs.google.com/spreadsheets/d/1p17JMSd5hCdC3ysMKBNecUVhIDM3v0q1WY3uHKgNklo/edit?usp=sharing",
  },
  {
    name: "Generate Timed Transcript for Passage Audio",
    path: "/scripts/passage_timed_transcript",
    description: "Upload Reading Content title to  generate timed transcript for reading content audios",
    sheet_link: "https://sheet.new",
  },
  {
    name: "Bulk Passage Explanation Upload",
    path: "/scripts/upload_passage_explanation",
    description: "Upload an Excel sheet having title and explanation(include \\n for linebreaks)",
    sheet_link: "https://docs.google.com/spreadsheets/d/1C2kB6PnLh1QS5uizXTx6J6BmHqaDqbkOEGKp8ifb2KE/edit?usp=sharing",
  },
];

